// // i18n.js (or wherever you configure i18next)
// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import en from './locales/en.json';  // path to en.json
// import fr from './locales/fr.json';  // path to fr.json

// i18n.use(initReactI18next).init({
//   resources: {
//     en: { translation: en },
//     fr: { translation: fr },
//   },
//   lng: 'en', // default language
//   fallbackLng: 'en', // fallback if a translation key is not found
//   interpolation: {
//     escapeValue: false, // React already escapes values
//   },
// });

// export default i18n;

// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'querystring', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage'], 
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

